import api from "../../config/client.axios.api";

export const getRevenueMachineApi = async (
  storeId: string,
  startDate: string,
  endDate: string
) => {
  const response = await api.get(`/history/get-revenue-machine`, {
    params: {
      storeId,
      startDate,
      endDate,
    },
  });
  return response.data;
};
